import React from 'react';
import { Layers } from 'lucide-react';
import { tierFor } from '../../services/stock';
import { useT } from '../../services/i18n';

const fmt = (v) => `${v.toFixed(2).replace('.', ',')} €`;

// Tyre pages: one-click x1 / x2 / x4 quantity shortcut showing the bundle price
const TyreBundleShortcut = ({ product, quantity, maxQty, onSelect }) => {
  const { t } = useT();
  if (!product.tyre) return null;
  const options = [1, 2, 4].filter((n) => n <= Math.max(maxQty, 1));
  return (
    <div className="mt-6" data-testid="tyre-bundle">
      <p className="text-sm font-semibold text-gray-900 mb-2 flex items-center gap-2"><Layers size={16} className="text-orange-500" /> {t('tyre.howMany')}</p>
      <div className="grid grid-cols-3 gap-2">
        {options.map((n) => {
          const tier = tierFor(product, n);
          const unit = Math.round(product.price * (1 - (tier?.discount_pct || 0) / 100) * 100) / 100;
          const active = quantity === n;
          return (
            <button key={n} type="button" onClick={() => onSelect(n)} data-testid={`tyre-bundle-${n}`}
              className={`relative rounded-lg border px-3 py-2.5 text-left transition-colors ${active ? 'border-orange-500 bg-orange-50 ring-1 ring-orange-500' : 'border-gray-200 hover:border-orange-300'}`}>
              {tier && <span className="absolute -top-2 right-2 rounded-full bg-green-600 px-1.5 py-0.5 text-[10px] font-bold text-white">−{tier.discount_pct} %</span>}
              <span className="block text-sm font-bold text-gray-900">{n === 1 ? t('tyre.one') : n === 4 ? t('tyre.set4') : t('tyre.n', { n })}</span>
              <span className="block text-xs text-gray-600">{fmt(unit * n)}{tier ? <span className="ml-1 text-gray-400 line-through">{fmt(product.price * n)}</span> : null}</span>
              <span className="block text-[11px] text-gray-500">{fmt(unit)} {t('tyre.perTyre')}</span>
            </button>
          );
        })}
      </div>
      {options.length < 3 && <p className="text-[11px] text-gray-500 mt-1">{t('tyre.insufficient')}</p>}
    </div>
  );
};

export default TyreBundleShortcut;
